module.exports = __webpack_public_path__ + "img/pengepugeren.0b27b22b.png";